module.exports = __webpack_public_path__ + "static/media/seal.aee877da.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/CA/seal.png
// module id = 1655
// module chunks = 0